import { render, staticRenderFns } from "./fourIndex.vue?vue&type=template&id=480192ee&scoped=true"
import script from "./fourIndex.vue?vue&type=script&lang=js"
export * from "./fourIndex.vue?vue&type=script&lang=js"
import style0 from "./fourIndex.vue?vue&type=style&index=0&id=480192ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480192ee",
  null
  
)

export default component.exports